// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + ({"354": "lib-axios","535": "lib-router",}[chunkId] || chunkId) + "." + {"125": "cf91006d","192": "c7dafb0a","354": "b478a622","535": "a4d580ac","887": "b9e03164","997": "c03f5808",}[chunkId] + ".js"
}